// extracted by mini-css-extract-plugin
export default {"ForwardButton":"forwardButton_ForwardButton__LTScM","path":"forwardButton_path__mYwbQ"};